module.exports = __webpack_public_path__ + "f49f6eb3711d22b033bb096bf3897f46.pdf";